import { ReactNode } from 'react';
import { Loading } from '@elementary/common-ui/components';
import { Outlet } from 'react-router-dom';
import NoEnvPage from 'shared/components/NoEnvPage';
import useEnvironments from 'shared/hooks/useEnvironments';
import EnvInitiatingPage from './EnvInitiatingPage';

const RequireEnv = ({ children }: { children?: ReactNode }): JSX.Element => {
  const { data: envData, selectedEnv, isLoading } = useEnvironments();

  const noEnvironments = !envData?.[0];
  const envInitializing = !selectedEnv?.lastSyncedAt;

  if (isLoading) {
    return <Loading />;
  }

  if (noEnvironments) {
    return <NoEnvPage />;
  }

  if (envInitializing) {
    return <EnvInitiatingPage />;
  }

  if (children) {
    return children as JSX.Element;
  }

  return <Outlet />;
};

export default RequireEnv;
